import { Spin as AntSpin, SpinProps as AntSpinProps } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { Typography } from '../../Typography';

export type LoaderSize = 'small' | 'default' | 'large';

export interface LoaderProps extends Omit<AntSpinProps, 'size' | 'tip'> {
  size?: LoaderSize;
  text?: string | React.ReactNode;
  className?: string;
}

const StyledSpin = styled(AntSpin)`
  .ant-spin-text {
    margin-top: ${theme.dime.spacing.m};
    margin-left: -28px; // hack to center text. They also have a hack on AntD documentation
  }
`;

export const Loader: React.FC<LoaderProps> = ({
  text,
  className = '',
  ...props
}) => {
  const tip = text ? (
    typeof text === 'string' ? (
      <Typography variant="body1">{text}</Typography>
    ) : (
      text
    )
  ) : undefined;

  return (
    <StyledSpin tip={tip} className={className} {...props}>
      <div />
    </StyledSpin>
  );
};
